export default __webpack_public_path__ + "static/basic-channels-6f7ed4047e35d8509e0d870ca25c53ad.png";